import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Typography from 'components/CncUI/Typography';

const useStyles = makeStyles(({ palette }) => ({
  errorRed: {
    color: palette.cncUI.alert.red.primary,
  },
  successGreen: {
    color: palette.cncUI.alert.green.primary,
  },
}));

const ValidationCircle = props => {
  const classes = useStyles();
  const { passwordLength, id, validate, label } = props;

  return (
    <Typography size="short" noMargin>
      {(passwordLength === 0 && (
        <CloseIcon id={`${id}Neutral`} className={classes.errorRed} />
      )) ||
        (validate && (
          <CheckIcon id={`${id}Success`} className={classes.successGreen} />
        )) || <CloseIcon id={`${id}Fail`} className={classes.errorRed} />}{' '}
      {label}
    </Typography>
  );
};

export default ValidationCircle;
